'use client';

import { cn } from '@/lib/utils';
import { CheckCheckIcon, CopyIcon } from 'lucide-react';
import { useState } from 'react';
import { Button } from './ui/button';

interface CopyButtonProps {
  code: string;
  className?: string;
  dark?: boolean;
}

export function CodeCopyButton({
  code,
  className,
  dark = true,
}: CopyButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className={cn('absolute right-2 top-2 z-10', className)}>
      <Button
        onClick={handleCopy}
        size="icon"
        variant="ghost"
        className={cn(
          'h-7 w-7 rounded-full transition-colors',
          dark
            ? 'border border-border bg-background/60 text-muted-foreground hover:bg-accent hover:text-foreground'
            : 'border border-slate-200 bg-white text-slate-500 hover:bg-slate-100 hover:text-slate-900',
        )}
      >
        {copied ? (
          <CheckCheckIcon className="w-4 h-4" />
        ) : (
          <CopyIcon className="w-4 h-4" />
        )}
      </Button>
    </div>
  );
}
